import {
  FETCH_DATA_ERROR,
  FETCH_DATA_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT,
  LOGOUT_FAILD,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  UPDATE_FORM_SIGNUP,
  UPDATE_IDLE_TIME_CLIENT,
  UPDATE_TIME_RESUME_CLIENT,
  RESET_LOGIN,
  EXPIRE_TOKEN_CLIENT,
  UPDATE_INFO_USER,
  UPDATE_DATA_FORM_AUTH,
  FETCH_ME_DATA_SUCCESS,
  FETCH_ME_DATA_ERROR,
  FETCH_ME_DATA,
} from "./types";
import { removeAxiosToken, settingApplication, setupAxios } from "core/networks/API";
import { config } from "../../../core/config/app";
import { deviceStorage } from "../../../core/utils/devicestorage";
import { getCodeLangById } from "core/utils/helper";
// import { getCodeLangById } from "core/utils/helper";


export interface DataState {
  token: string;
  expireToken: boolean;
  type: string;
  userInfo: object;
  loginSuccess: any;
  loginFailed: any;
  isProcessing: boolean;
  isLoadingLogin: boolean;
  statusCode: any;
  isProcessingUpdate: boolean;
  idleTime: any;
  timeResume: any;
  dataForm: any;
  langCode: string;
  typeLogin: string;
}

const initialState: DataState = {
  token: "",
  expireToken: false,
  type: "",
  userInfo: {},
  loginSuccess: null,
  loginFailed: null,
  isLoadingLogin: false,
  isProcessing: false,
  statusCode: null,
  isProcessingUpdate: false,
  idleTime: null,
  timeResume: null,
  dataForm: {},
  langCode:(window as any)._APP_LANG,
  typeLogin: "GMAIL", // default
};


const ClientReducer = (state: DataState = initialState, action: any): DataState => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoadingLogin: true,
        type: action.type,
        userInfo: action.payload?.user,
        typeLogin: action.payload?.type || "GMAIL",
      };
    case LOGIN_SUCCESS: {
      // deviceStorage[localStorage.getItem("storage_driver") || "session"].setItem(config.appPackage + '_X_TOKEN', action.payload?.data?.token)
      const languages = localStorage.getItem("languages");
      const code = getCodeLangById(action.payload?.data?.user?.lang_id, (languages ? JSON.parse(languages) : []));
      // @ts-ignore
      (window as any)._APP_LANG = code;
      settingApplication();
      setupAxios();
      // setAxiosToken(action.payload?.data?.token);
      
      return {
        ...state,
        isLoadingLogin: false,
        type: action.type,
        token: action.payload?.data?.token || "",
        loginSuccess: action.payload,
        userInfo: action.payload?.data?.user || {},
      };
    }
    case LOGIN_FAILED:
      return {
        ...state,
        isLoadingLogin: false,
        loginFailed: action.payload || {},
        type: action.type,
        userInfo: action.payload?.user,
      };
    case RESET_LOGIN:
      return {
        ...state,
        isLoadingLogin: false,
        loginFailed: null,
        expireToken: false,
      };

    case EXPIRE_TOKEN_CLIENT:
      // removeAxiosToken();
      return {
        ...state,
        expireToken: true,
      };
    case FETCH_DATA_SUCCESS:
      // @ts-ignore
      // initSocket(
      //   deviceStorage[
      //     localStorage.getItem("storage_driver") || "session"
      //   ].getItem(config.appPackage + config.appPackage + "_X_TOKEN")
      // );
      //console.log('action.payload', action.payload);

      return {
        ...state,
        token: deviceStorage[localStorage.getItem("storage_driver") || "session"].getItem(config.appPackage + '_X_TOKEN'),
        userInfo: { ...action.payload },
        type: action.type
      };
    case FETCH_DATA_ERROR:
      // @ts-ignore
      if (window.socket)
        // @ts-ignore
        window.socket.disconnect();
      return { ...initialState, type: action.type };
    case FETCH_ME_DATA:
      return {
        ...state,
        type: action.type,
      };
    case FETCH_ME_DATA_SUCCESS:
      return {
        ...state,
        token: deviceStorage[localStorage.getItem("storage_driver") || "session"].getItem(config.appPackage + '_X_TOKEN'),
        userInfo: { ...action.payload },
        type: action.type
      };
    case FETCH_ME_DATA_ERROR:
      return { ...initialState, type: action.type };
    case UPDATE_FORM_SIGNUP:
      return {
        ...initialState,
        type: action.type,
      };
    case UPDATE_IDLE_TIME_CLIENT:
      return { ...state, type: action.type, idleTime: action.payload };
    case UPDATE_TIME_RESUME_CLIENT:
      return { ...initialState, type: action.type, timeResume: action.payload };
    case LOGOUT_REQUEST:
      console.log(state,'LOGOUT_REQUEST',action.payload)
      return {
        ...state,
        isProcessing: true,
        expireToken: false,
        type: action.type,
        langCode: action.payload
      };
    case LOGOUT_SUCCESS:
      removeAxiosToken();
      deviceStorage[localStorage.getItem("storage_driver") || "session"].setItem(config.appPackage + '_APP-LANG', state.langCode)
      return {
        ...initialState,
        isProcessing: false,
        token: "",
        statusCode: 400,
        expireToken: false,
        userInfo: {},
        type: action.type,
      };
    case LOGOUT_FAILD:
      return {
        ...state,
        isProcessing: false,
        expireToken: false,
        token: "",
        statusCode: 400,
        userInfo: {},
        type: action.type,
      };
    case UPDATE_INFO_USER:
      return {
        ...state, type: action.type, userInfo: {
          ...state.userInfo,
          ...action?.payload,
          avatar: action.payload.avatar,
          setting: action.payload?.setting,
        }
      };

    case UPDATE_DATA_FORM_AUTH:
      return {
        ...initialState,
        type: action.type,
        dataForm: action.payload
      };
    case LOGOUT:
      removeAxiosToken();
      // @ts-ignore
      if (window.socket) {
        // @ts-ignore
        window.socket.disconnect();
      }

      return { ...initialState, expireToken: false, type: action.type };
    default:
      return state;
  }
};

export default ClientReducer;
